import * as Popover from "@radix-ui/react-popover";
import * as Select from "@radix-ui/react-select";
import { Clock, ChevronDown, Check } from "lucide-react";
import { useState } from "react";

export default function TimePicker({ value, onChange }) {
    const [open, setOpen] = useState(false);
    const [hour, setHour] = useState("08");
    const [minute, setMinute] = useState("00");
    const [period, setPeriod] = useState("AM");

    const updateTime = (h, m, p) => {
        const finalHour = h ?? hour;
        const finalMinute = m ?? minute;
        const finalPeriod = p ?? period;

        setHour(finalHour);
        setMinute(finalMinute);
        setPeriod(finalPeriod);

        const formatted = `${finalHour}:${finalMinute} ${finalPeriod}`;
        onChange?.(formatted);
    };

    return (
        <Popover.Root open={open} onOpenChange={setOpen}>
            <Popover.Trigger asChild>
                <button className="flex h-12 w-full items-center justify-between rounded-lg border px-4 text-sm bg-white focus:outline-none">
                    {value || "Pick time"}
                    <Clock size={18} className="text-gray-500" />
                </button>
            </Popover.Trigger>

            <Popover.Portal>
                <Popover.Content
                    side="bottom"
                    align="start"
                    sideOffset={6}
                    className="z-50 rounded-xl border bg-white p-4 shadow-xl"
                >
                    <div className="flex gap-3">

                        <TimeSelect
                            value={hour}
                            onChange={(val) => updateTime(val, null, null)}
                            items={Array.from({ length: 12 }, (_, i) =>
                                String(i + 1).padStart(2, "0")
                            )}
                        />

                        <TimeSelect
                            value={minute}
                            onChange={(val) => updateTime(null, val, null)}
                            items={Array.from({ length: 60 }, (_, i) =>
                                String(i).padStart(2, "0")
                            )}
                        />

                        <TimeSelect
                            value={period}
                            onChange={(val) => updateTime(null, null, val)}
                            items={["AM", "PM"]}
                        />

                    </div>
                </Popover.Content>
            </Popover.Portal>
        </Popover.Root>
    );
}

function TimeSelect({ value, onChange, items }) {
    return (
        <Select.Root value={value} onValueChange={onChange}>
            <Select.Trigger className="flex h-10 w-20 items-center justify-between rounded-md border px-2 text-sm">
                <Select.Value />
                <Select.Icon>
                    <ChevronDown size={14} />
                </Select.Icon>
            </Select.Trigger>

            <Select.Portal>
                <Select.Content
                    position="popper"
                    side="bottom"
                    className="z-50 max-h-48 w-20 overflow-auto rounded-md border bg-white shadow-lg"
                >
                    <Select.Viewport>
                        {items.map((item) => (
                            <Select.Item
                                key={item}
                                value={item}
                                className="relative flex cursor-pointer select-none items-center py-1.5 pl-6 pr-2 text-sm hover:bg-gray-100 data-[state=checked]:bg-blue-50"
                            >
                                <Select.ItemText>{item}</Select.ItemText>
                                <Select.ItemIndicator className="absolute left-1">
                                    <Check size={14} />
                                </Select.ItemIndicator>
                            </Select.Item>
                        ))}
                    </Select.Viewport>
                </Select.Content>
            </Select.Portal>
        </Select.Root>
    );
}